import { Location, PlatformLocation } from '@angular/common';
import { Component, effect, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TabsModule } from 'primeng/tabs';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-tabs',
  standalone: true,
  imports: [TabsModule, TranslateModule],
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent {
  private readonly router = inject(Router);
  private readonly platformLocation = inject(PlatformLocation);
  private readonly location = inject(Location);

  tabs = [
    {
      label: 'menu.home',
      icon: 'icon-home',
      route: '/',
    },
    {
      label: 'menu.map',
      icon: 'icon-map-pin',
      route: '/map',
    },
    {
      label: 'menu.notifications',
      icon: 'icon-info',
      route: '/notifications',
    },
    {
      label: 'my.menu.profile',
      icon: 'icon-user',
      route: '/mobile-profile',
    },
  ];

  activeItem = signal<string>(
    this.tabs.find((item) => {
      // We use platformLocation.pathname instead of router.url
      // because the latter gives the incorrect path in the constructor
      return this.platformLocation.pathname === item.route;
    })?.route ?? this.tabs[0].route,
  );

  constructor() {
    this.location.onUrlChange((_url, _state) => {
      if (this.platformLocation.pathname !== this.activeItem()) {
        // Update the active tab when the path is changed by something else (i.e. when authenticating)
        const tabCorrespondingToPath = this.tabs.find((tab) => tab.route === this.platformLocation.pathname);
        if (tabCorrespondingToPath) {
          this.activeItem.set(tabCorrespondingToPath.route);
        }
      }
    });

    effect(() => {
      // On active item change, navigate to new location (if we're not already there or authenticating)
      const activeItem = this.activeItem();
      if (
        this.platformLocation.pathname !== activeItem &&
        this.platformLocation.pathname !== environment.okta_redirectPath
      ) {
        void this.router.navigate([activeItem]);
      }
    });
  }
}
